export default __webpack_public_path__ + "static/media/background_our_experience_desktop.569ac0cb.png";